import type { ReactNode } from 'react';

// ONE TITLED WHITE CARD. Phase 5 draws a part, and a part is two of these: one for the
// SOURCE of the mesh — a photograph to model from, a CAD file, a set of measurements — and
// one for looking at what came back.
//
// A CARD EACH, and not two halves of one. They shared a rectangle, on the reasoning that
// picking a photograph and looking at what it produced are one thing happening — which is
// true of the two of them and stops being true of what has grown inside them. The lower
// half is a viewer, a strip of every mesh the part has had, and four bands of controls; the
// upper is a row of pictures and a button. One border around all of that says "this is one
// thing to read" about half a screen of scrolling, and the heading in the middle of it was
// the only thing saying otherwise.
//
// Its own file because Phase 5 has two of these cards twice over — per part (ThreeDStep)
// and for the whole product (ProductModelStep) — and the card is the thing that makes them
// read as the same panel answering the same two questions. The width is its own for the
// same reason: it was on the rectangle that held both, and a card that took whatever width
// it was given would be two different cards on the two pages.
// A HEADING PLUS WHAT MADE IT: "3D model (GPT-6 Astra)". Written once because two panels
// wear it — the part's viewer and the product's — and a parenthesis that differed between
// them would read as two different facts.
export const panelTitle = (title: string, suffix: string | null | undefined) =>
  (suffix ? `${title} (${suffix})` : title);

// The panel's heading, as a class: the zoomed-in modal opens with the same words in the same
// letters, so the two cannot drift into two headings for one mesh.
export const PANEL_TITLE_CLASS =
  'text-center text-[11px] font-bold uppercase tracking-wider text-slate-500';

// `corner`: a control under the title, centred — which of the hardware's models is on screen.
// AS WIDE AS THE PHASE (max-w-6xl, it was 4xl): the viewer's controls stand in a column beside it,
// on both sides' worth of room so it stays centred, and at 4xl that left the picture a strip
// (Louis 2026-10-28).
export function MeshPanel({ title, corner, children }: { title: string; corner?: ReactNode; children: ReactNode }) {
  return (
    <section className="relative mx-auto w-full max-w-6xl rounded-xl border border-slate-200 bg-white p-4">
      <h4 className={`mb-3 ${PANEL_TITLE_CLASS}`}>
        {title}
      </h4>
      {corner && <div className="mb-3 flex justify-center">{corner}</div>}
      {children}
    </section>
  );
}
